import "react-app-polyfill/ie11";
import 'react-app-polyfill/stable';
import 'intersection-observer';
import 'wdpr-ra-javascript-native-bridge/dist/wdpr-ra-javascript-native-bridge';
import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import initHybird from './utils/hybird';
import get from 'lodash/get';
import MainEntry from './Main';
import HybirdContextContainer from './containers/HybirdContext.container';
import * as serviceWorker from './serviceWorker';

if (/2021408/.test(window.location.href)) {
  document.body.style.background = '#FCE9DF';
} else {
  document.body.style.background = '#7273dd';
}

function _init(cb) {
  const bridgeRetryTimes = 10;
  const bridgeRetryDelay = 300;
  let _nativeBridge;
  let bridge;
  let _device = {
    embedded: null,
    platform: {
      ios: null,
      android: null
    }
  };
  let initTimes = 0;
  let timeoutHandler;
  function waitJSBridgeReady() {
    initTimes++;
    _nativeBridge = get(window, 'disney.nativeBridgeFactory.createNativeBridge');
    _device = get(window, 'disney.device');
    console.log(33333, _nativeBridge);
    if (!bridge) {
      console.log('waitJSBridgeReady is called', _nativeBridge);
      try {
        bridge = _nativeBridge();
        bridge.sendReadyMessage({}, function (commandName, params, error) {
          console.log(`sendReadyMessage Failure callback: ${commandName}`);
          throw new Error(`sendReadyMessage Failure: ${error}`);
        })
      } catch (e) {
        console.log(`call createNativeBridge failed: ${e}`);
      }

      if (initTimes < bridgeRetryTimes) {
        timeoutHandler = setTimeout(() => {
          console.log('BridgeReady is retrying', initTimes);
          waitJSBridgeReady();
        }, bridgeRetryDelay);
      } else {
        console.log('BridgeReady max retry reached', bridge);
        cb(initHybird());
      }
    } else {
      console.log('BridgeReady with existing object', bridge);
      cb(initHybird(bridge));
    }
  }
  waitJSBridgeReady();
}

_init((hybirdBridge) => {
  console.log('BridgeReady init phase pass: ', hybirdBridge);
  ReactDOM.render(
    <React.StrictMode>
      <HybirdContextContainer bridge={hybirdBridge}>
        <MainEntry />
      </HybirdContextContainer>
    </React.StrictMode>,
    document.getElementById('root')
  );
});


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
